import moment from "moment";
import React from "react";
import { AiFillStar } from "react-icons/ai";

import ReactTooltip from "react-tooltip";
import { isArray } from "underscore";

import "./pickDropsCard.css";

import { FaUsers } from "react-icons/fa";
import { toHHMMSS } from "../reports/ReportFilter";
import { _getTimeDuration } from "../../configs/duration";
import { TASK_ASSETS_URL } from "../../environments/environments";
import CustomerField, {
  _customerFields,
} from "../taskManager/FieldsCard/CustomerField";
import { _driverFields } from "../taskManager/FieldsCard/DriverFields";
import ChatCount from "../taskManager/task/ChatCount/ChatCount";
import StatusButton from "../taskManager/task/StatusButton";
import { arrayMoveImmutable } from "array-move";
import { useSelector } from "react-redux";

export const _getRowFields = (cardSettings, rowNumber) => {
  if (!cardSettings) return [];

  return cardSettings.filter((cs) =>
    rowNumber == 2 ? cs.row == 2 : !cs.row || cs.row == "1",
  );
};

export const matchWithField = (field) => {
  if (field.type == "job" && field.label == "Job Name")
    field.type = "description";
  if (field.type == "s_time") field.type = "fromTime";
  if (field.type == "e_time") field.type = "toTime";
  if (field.type == "s_address") field.type = "startAddress";
  if (field.type == "e_address") field.type = "endAddress";
  if (field.type == "map") field.type = "endAddress";
  if (field.type == "contact") field.type = "phoneNumber";
  if (field.type == "endAddress") field.type = "address";

  return field;
};

export const _getFieldData = (
  task,
  field,
  statusList = [],
  statusLocationsList = [],
  showFields = {},
) => {
  var statusChangedByList =
    showFields && isArray(showFields?.taskStatus)
      ? showFields.taskStatus.map((s) => `${s.label.toLowerCase()} by`)
      : [];

  field = matchWithField(field);


  if (statusList.includes(field.key)) {
    if (task.statusActivities && isArray(task.statusActivities)) {
      var reversedArray = [...task.statusActivities].reverse();

      const exist = reversedArray.findIndex(
        (t) => `${t.status.toLowerCase()} time` == field.label.toLowerCase(),
      );
      return exist != -1
        ? moment(reversedArray[exist].date).format("yyyy-MM-DD HH:mm")
        : "-";
    } else {
      return "-";
    }
  }

  if (statusLocationsList.includes(field.key)) {
    if (task.statusActivities && isArray(task.statusActivities)) {
      var reversedArray = [...task.statusActivities].reverse();

      const exist = reversedArray.findIndex(
        (t) =>
          `${t.status.toLowerCase()} location` == field.label.toLowerCase(),
      );
      return exist >= 0 && reversedArray[exist].location
        ? reversedArray[exist].location?.address
        : "-";
    } else {
      return "-";
    }
  }
  if (statusChangedByList.includes(field.label.toLowerCase())) {
    if (task.statusActivities && isArray(task.statusActivities)) {
      var reversedArray = [...task.statusActivities].reverse();

      const exist = reversedArray.findIndex(
        (t) => `${t.status.toLowerCase()} by` == field.label.toLowerCase(),
      );
      return exist >= 0 && reversedArray[exist].user
        ? reversedArray[exist].user
        : "-";
    } else {
      return "-";
    }
  }

  // FROM TASK
  if (task[field.key] && field.type !== "populate")
    return (
      <small className="task__stats__val font-13">{task[field.key]}</small>
    );

  //  FOR TIME
  if (field.type == "time")
    return (
      <small className="task__stats__val font-13">
        {task?.fromTime}-{task?.toTime}
      </small>
    );

  // // FROM DRIVER
  // if(task.driver && task.driver[_driverFields[field.type]]) return <small className="task__stats__val">{ task.driver[_driverFields[field.type]] }</small>;

  // const _cf = _customerFields[field.type] ? _customerFields[field.type] : field.type

  // FROM CUSTOMER
  if (field.key == "customer" && field.type == "populate" && task.customer)
    return (
      <small className="task__stats__val font-13">
        {task.customer.name} ({task.customer.phoneNumber})
      </small>
    );

  // FROM ATTRIBUTES
  if (task.attributes && task.attributes[field.key]) {
    if (["Image", "image"].indexOf(field.type) !== -1) {
      return (
        <img
          src={`${TASK_ASSETS_URL}/${task.attributes[field.key]}`}
          width="60"
          height="60"
          style={{ objectFit: "cover" }}
        />
      );
    } else if (["Sigature", "signature"].indexOf(field.type) !== -1) {
      return (
        <img
          src={task.attributes[field.key]}
          width="60"
          height="60"
          style={{ objectFit: "cover" }}
        />
      );
    } else {
      return (
        <small className="task__stats__val font-13">
          {task.attributes[field.key]}
        </small>
      );
    }
  }

  return "-";
};

const PickDropsCard = (props) => {
  const {
    id,
    task,
    isActive,
    onClick,
    toggleChatWindow,
    showFields,
    activeDriver = false,
    cardSettings,
    statusList,
    statusLocationsList,
    className = "",
    timelineDuration = false,
    fromTimeLine = false,
  } = props;

  // const activeDriver = useSelector((state) => state.taskReducer.activeDriver);

  const classes = isActive == true ? "singleTaskActive" : "";
  const active = isActive == true ? "taskordersectionActive" : "";

  // const firstRow = _getRowFields(cardSettings, 1);
  const firstRow = [
    {
      order: 1,
      type: "text",
      label: "Job Description",
      key: "description",
    },
    {
      order: 2,
      type: "populate",
      label: "Location",
      key: "customer",
    },
    {
      order: 3,
      type: "test",
      label: "Name",
      key: "name",
    },
  ];

  const seoundRow = _getRowFields(cardSettings, 2);

  return (
    <React.Fragment>
      <div
        onClick={onClick}
        className={`task ${isActive ? "active" : ""} ${className}`}
      >
        <div className="d-flex bd-highlight">
          <div className="mr-auto p-2 bd-highlight">
            <span className="task__tag task__tag--copyright mr-2">
              #{id + 1}
            </span>
            {/* {(task.hasRepeatTask ||
              (task.parentTask && task.parentTask != "")) && (
            //   <img
            //     className="mr-2"
            //     data-tip="Created from the Scheduler"
            //     src={require("../../../assets/img/repeat.png").default}
            //     height={20}
            //     alt=""
            //   />
            )} */}

            {task.isSharedWithGroup && (
              <FaUsers
                data-tip={
                  task.isSharedJobStartedByDriver
                    ? `This is the group task & work started by ${task.driver.name}`
                    : "Group Task"
                }
                size={20}
                color={task.isSharedJobStartedByDriver ? "#2d66ef" : "grey"}
              />
            )}

            {!activeDriver && (
              <span className="task__stats ml-2">{task.driver?.name}</span>
            )}
          </div>
          {task.uniqueId && ( // .jobId
            <div className="p-2 bd-highlight">
              <span className="task__stats mr-2">
                <span className="font-weight-bold">#</span>
                {task.uniqueId}
              </span>
            </div>
          )}
          <div className="p-2 bd-highlight">
            <span className="task__stats mr-2">
              {task.date && task.date !== "" && (
                <time dateTime={task.date}>
                  <i className="fas fa-calendar-day"></i>{" "}
                  {moment(task.date).format("DD-MM-YYYY")}{" "}
                </time>
              )}
            </span>
          </div>

          {timelineDuration !== false && (
            <div className="p-2 bd-highlight">
              <span className="task__stats">
                {" "}
                Time{" "}
                {moment(task?.EstimatedFromTime, "HH:mm:ss").format(
                  "HH:mm A",
                )}{" "}
                - {moment(task?.EstimatedToTime, "HH:mm:ss").format("HH:mm A")}{" "}
                [
                {_getTimeDuration(
                  task?.EstimatedFromTime,
                  task?.EstimatedToTime,
                )}
                ]{" "}
              </span>
              {/* {task.travelingTime ? (
                <span className="task__stats">
                  {" "}
                  Travel Time {toHHMMSS(
                    task.travelingTime * 1000,
                    "HH:mm"
                  )}{" "}
                </span>
              ) : null} */}
            </div>
          )}
          <div className="p-2 bd-highlight">
            <span className="task__owner">
              <StatusButton
                status={task.status}
                statusList={showFields.taskStatus}
              />
            </span>
          </div>
          {/* {task.isOptimizedByExcludingTimeWindow && fromTimeLine ? (
            <div className="py-2">
              <img
                src={
                  require("../../../assets/img/task_manager_icons/exclude-time-window.png")
                    .default
                }
                style={styles.excludeTimeWindowIcon}
              />
            </div>
          ) : (
            <></>
          )} */}
        </div>

        {/*  Row 1  */}

        <div
          className="d-flex justify-content-between"
          style={{ borderBottom: "1px solid #f9f9f9" }}
        >
          {firstRow.map((fr, i) => (
            <span key={i} className="align-items-center eclips">
              {" "}
              <small className="task__stats"> {fr.label} : </small>{" "}
              <small className="task__stats__val font-13">
                {_getFieldData(
                  task,
                  fr,
                  statusList,
                  statusLocationsList,
                  showFields,
                )}
              </small>{" "}
            </span>
          ))}
        </div>

        {/*  Row 2  */}

        <div className="d-flex justify-content-between">
          {seoundRow.map((fr, i) => (
            <div
              key={i}
              style={{
                maxWidth:
                  seoundRow.length <= 2
                    ? seoundRow.length == 1
                      ? "100%"
                      : "60%"
                    : "33%",
              }}
              className="eclips align-items-center"
            >
              {" "}
              <small className="task__stats"> {fr.label} : </small>{" "}
              <small className="task__stats__val font-13">
                {_getFieldData(
                  task,
                  fr,
                  statusList,
                  statusLocationsList,
                  showFields,
                )}
              </small>{" "}
            </div>
          ))}
        </div>
      </div>

      <ReactTooltip class="tooltip" />
    </React.Fragment>
  );
};

const styles = {
  container: {
    backgroundColor: "#ffffff",
    fontSize: "13px",
    padding: "12px 5px",
    boxShadow: "0 4px 15px 0 rgba(0, 0, 0, 0.1)",
    borderRadius: "10px",
    width: "100%",
  },
  status: {
    outline: "none",
    border: "1px solid #1214b1",
    color: "#1214b1",
    fontSize: "11px",
    borderRadius: "3px",
    whiteSpace: "nowrap",
    backgroundColor: "#cae0f2",
  },
  grayHead: {
    color: "gray",
    fontSize: "12px",
    marginBottom: "-3px",
  },
  count: {
    padding: "0px 10px",
    border: "1px solid #e2e2e2",
    height: "22px",
    borderRight: "0px",
    marginTop: "10px",
    fontSize: "12px",
    borderRadius: "4px 0 0 4px",
  },
  image: {
    position: "relative",
    top: -10,
  },
  excludeTimeWindowIcon: {
    height: 20,
  },
};

export default PickDropsCard;
